import store from '../../../../store';
import { selectAppId } from '../../../../store/v1/auth/auth.selectors';
import { forcedFeatureFlags } from '../../../features';
import { myEnterpriseService } from '../../io/EnterpriseService/EnterpriseService.connected';
import { myEnterpriseFeatureFlagService } from '../../io/EnterpriseFeatureFlagService/EnterpriseFeatureFlagService.connected';
import { myLocalStorageFeatureFlagSource } from '../FeatureService/_private/localStorageFeatureFlagSource';
import { myToastService } from '../ToastService/ToastService.connected';
import { createFeatureManagementService } from './FeatureManagementService.impl';

export const myFeatureManagementService = createFeatureManagementService({
  services: { toastService: myToastService },
  enterpriseFeatureFlagService: myEnterpriseFeatureFlagService,
  enterpriseService: myEnterpriseService,
  localStorageSource: myLocalStorageFeatureFlagSource,
  enforcedVersions: forcedFeatureFlags,
  getOrganizationId: () => selectAppId(store.getState()),
  hostname: window.location.hostname
});
